<ng-container *ngIf="showLayout; else authLayout">
  <div class="app-shell">
    <button class="mobile-menu-button" type="button" (click)="toggleSidebar()">
      ☰
    </button>

    <div
      class="sidebar-backdrop"
      *ngIf="sidebarOpen"
      (click)="closeSidebar()"
    ></div>

    <aside class="sidebar" [class.sidebar-open]="sidebarOpen">
     <div class="brand">
  <img
    src="assets/logo-white.svg"
    alt="CODEIP"
    class="brand-logo"
  />
</div>

      <p class="brand-description">
       Converte agora seu saldo
      </p>

      <nav class="menu">
        <a routerLink="/dashboard" routerLinkActive="active" (click)="closeSidebar()">
          ▦ &nbsp;Dashboard
        </a>

        <a routerLink="/deposit" routerLinkActive="active" (click)="closeSidebar()">
          ↓ &nbsp;Deposito
        </a>

        <a routerLink="/convert" routerLinkActive="active" (click)="closeSidebar()">
          ⇄ &nbsp;Converter
        </a>

        <a routerLink="/withdraw" routerLinkActive="active" (click)="closeSidebar()">
          ↑ &nbsp;Sacar USDT
        </a>

        <a routerLink="/statement" routerLinkActive="active" (click)="closeSidebar()">
          ≣ &nbsp;Extrato
        </a>

        <a routerLink="/profile" routerLinkActive="active" (click)="closeSidebar()">
          ◎ &nbsp;Configurações
        </a>

        <a href="javascript:void(0)" (click)="logout()">
          ⏻ &nbsp;Sair
        </a>
      </nav>

      
    </aside>

    <main class="main-content">
      <router-outlet></router-outlet>
    </main>

    <app-limit-status-modal></app-limit-status-modal>
  </div>
</ng-container>

<ng-template #authLayout>
  <router-outlet></router-outlet>
</ng-template>